import store from '@/store'
import router from '@/router'

export default {
  install: (Vue, options) => {
    Vue.prototype.$applicantAuth = {
      logout: async () => {
        router.push({ name: 'onlineapplications' })
        store.commit('UPDATE_APP_FORM_TOKEN', { token: null })
        store.commit('UPDATE_APPLICANT_ID', { id: null })
        localStorage.removeItem('app_form_token')
        localStorage.removeItem('applicant_id')
      },
    }
  },
}
